<template>
	<div class="pay-ment-body">
		<el-steps :active="step" finish-status="success" simple>
			<el-step title="确认订单"></el-step>
			<el-step title="支付"></el-step>
			<el-step title="支付成功"></el-step>
		</el-steps>
	</div>
</template>
<script>
	export default {
		props: ['step']
	}
</script>
<style>
.pay-ment-body .el-step__head.is-success{
	color: #228ae7;
	border-color: #228ae7;
}
.pay-ment-body .el-step__title.is-success{
	color: #228ae7;
}
</style>
<!-- <template>
	<div class="t-progress" :class="'className'">
        <div id="stepOne" :class="{'is-active': step == '1'}" class="step">
			<icon-svg class="menu-icon mr10" name="icon-zhengpinbaozhangduigou"></icon-svg>
            <div class="p-txt">确认订单</div>
        </div>
        <div id="stepTwo" :class="{'is-active': step == '2'}" class="step">
			<icon-svg class="menu-icon mr10" name="icon-zhanghu"></icon-svg>
            <div class="p-txt">支付</div>
        </div>
        <div id="stepThr" :class="{'is-active': step == '3'}" class="step">
			<icon-svg class="menu-icon mr10" name="icon-feiyong"></icon-svg>
            <div class="p-txt">支付成功</div>
        </div>
    </div>
</template>

<script>
import iconSvg from '@components/icon-svg'

export default {
    props: ['className', 'step'],
    components: {
    	iconSvg
    }
}
</script>

<style scoped>
	.t-progress{
		display: flex;
		overflow: hidden;
	}
	.step{
		float: left;
		flex: 1;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #a5a5a5;
	}
	.is-active{
		color: #f00
	}

	.p-txt{
		font-size: 16px;
		color: #a5a5a5;
		font-weight: bold;
		display: inline;
	}

	.is-active .p-txt{
		color: #fff;
	}

	.is-active#stepOne{
		color: #fff;
		background: #20b09f !important;
	}

	.is-active#stepOne:after{
		border-left-color: #20b09f !important;
	}

	.is-active#stepTwo{
		color: #fff;
		background: #20b09f !important;
	}

	.is-active#stepTwo:after{
		border-left-color: #20b09f !important;
	}

	.is-active#stepThr{
		color: #fff;
		background: #20b09f !important;
	}

	#stepOne {
	    height: 80px;
	    position: relative;
	    background: #e5e5e5;
	    z-index: 3;
	}
	#stepOne:before{
		content: "";
	    height: 0;
	    left: 100%;
	    top: -6px;
	    position: absolute;
	    border-top: 46px solid transparent;
	    border-left: 23px solid #fff;
	    border-bottom: 46px solid transparent;
	}
	#stepOne:after {
	    content: "";
	    width: 0;
	    height: 0;
	    left: 100%;
	    top: 0;
	    position: absolute;
	    border-top: 40px solid transparent;
	    border-left: 20px solid #e5e5e5;
	    border-bottom: 40px solid transparent;
	}

	#stepTwo {
	    height: 80px;
	    position: relative;
	    background: #e5e5e5;
	    z-index: 2;
	}
	#stepTwo:before{
		content: "";
	    height: 0;
	    left: 100%;
	    top: -6px;
	    position: absolute;
	    border-top: 46px solid transparent;
	    border-left: 23px solid #fff;
	    border-bottom: 46px solid transparent;
	}
	#stepTwo:after {
	    content: "";
	    width: 0;
	    height: 0;
	    left: 100%;
	    top: 0;
	    position: absolute;
	    border-top: 40px solid transparent;
	    border-left: 20px solid #e5e5e5;
	    border-bottom: 40px solid transparent;
	}

	#stepThr{
	    height: 80px;
	    position: relative;
	    background: #e5e5e5;
	    z-index: 1;
	}

</style> -->



// WEBPACK FOOTER //
// src/Payment/components/private-component/Steps.vue